export default __webpack_public_path__ + "static/media/pearlHacks.926425f6.png";